<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="rhqCode" @change="categoryList(5)">
                                            <option value="" v-if="roles.includes('9900') || roles.includes('4900')">
                                                {{ $t('FIELD.FAST.DURATION.ALL') }}
                                            </option>
                                            <option
                                                v-for="item in rhqCodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="searchSubsidiary">
                                            <option
                                                value=""
                                                v-if="
                                                    roles.includes('9900') ||
                                                        roles.includes('4900') ||
                                                        roles.includes('3900')
                                                "
                                            >
                                                {{ $t('FIELD.FAST.DURATION.ALL') }}
                                            </option>
                                            <option
                                                v-for="item in searchSubsidiaryList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.GBM') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <select class="slt_white w100p" v-model="gbm_cd" :disabled="disabledGbm">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in gbmCdList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.CATEGORY') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_3">
                                    <div>
                                        <select
                                            class="slt_white w100p"
                                            v-model="category1Code"
                                            @change="categoryList(2)"
                                        >
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category1CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select
                                            class="slt_white w100p"
                                            v-model="category2Code"
                                            @change="categoryList(3)"
                                        >
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category2CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100p" v-model="category3Code">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category3CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.INQUIRY') }}</li>
                            <li data-input-type="date" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100p" v-model="inquiry1Code" @change="inquiryList(2)">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry1CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100p" v-model="inquiry2Code">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry2CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('TITLE.GLOBAL.ANSWERERS') }}</li>
                            <li data-input-type="input" class="w100-150">
                                <div>
                                    <label class="serach-wrap">
                                        <input type="text" v-model="loginNm" class="text_input" disabled />
                                        <a href="javascript:" class="in_btn_search" @click="searchUserPop()">
                                            <i class="ico_input_serach"></i>
                                            <span class="sr_only"></span>
                                        </a>
                                    </label>
                                    <a href="javascript:" class="btn_white" @click="resetClick()">
                                        {{ $t('BUTTON.GLOBAL.RESET') }}
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.KPIINCHARGE') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100p" v-model="kpi_charge">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in kpiChargeList" :key="pageName + item.CD" :value="item.CD">
                                        {{ item.CD_NAME }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.DELETE') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w33_3" v-model="del_yn">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option value="N">N</option>
                                    <option value="Y">Y</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.NOT.MAPPED') }}</li>
                            <li data-input-type="checkbox" class="w100-150">
                                <label class="checkbox-wrap mr10">
                                    <input
                                        type="checkbox"
                                        name=""
                                        value=""
                                        v-model="mappingYN"
                                        true-value="Y"
                                        false-value="N"
                                    />
                                    <i class="check-icon"></i>
                                    <em></em>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch(1)">{{
                                $t('BUTTON.GLOBAL.SEARCH')
                            }}</a>
                        </span>
                    </div>
                </article>
            </div>
            <!--tab-->
            <div class="tab_wrap">
                <ul class="tab_menu_04 tab_menus">
                    <li class="on" @click="tabClick(0)">
                        <a href="javascript:">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</a>
                    </li>
                    <li class="" @click="tabClick(1)">
                        <a href="javascript:">{{ $t('FIELD.GLOBAL.RHQ') }}</a>
                    </li>
                    <li class="" @click="tabClick(2)">
                        <a href="javascript:">{{ $t('FIELD.GLOBAL.GBM') }}</a>
                    </li>
                    <div class="btn_wrap fR">
                        <a href="javascript:" class="btn_white" @click="answererAddPop()">
                            {{ $t('BUTTON.GLOBAL.ADD') }}
                        </a>
                        <a href="javascript:" class="btn_white" @click="modify()">
                            {{ $t('BUTTON.GLOBAL.DELETE') }}
                        </a>
                        <a href="javascript:" class="btn_white" @click="answererChangePop()">
                            {{ $t('BUTTON.GLOBAL.CHANGEANSWERER') }}
                        </a>
                        <a href="javascript:" class="btn_white" v-if="success5" @click="europeSharedSvcPop()">
                            {{ $t('BUTTON.GLOBAL.SHARED.SVC') }}
                        </a>
                        <a href="javascript:" class="btn_white" @click="onExcel()">
                            {{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}
                        </a>
                    </div>
                </ul>
                <div class="tab_contents">
                    <div class="tab_cont">
                        <div class="grid_wrap">
                            <toast-grid
                                gridId="subAnswererManageListGrid"
                                :columns="subColumns"
                                :data="subAnswerList"
                                :options="options"
                                ref="subAnswererManageListGrid"
                                :key="subGridKey"
                                :isTotalCount="false"
                                :click="contentClick"
                            />
                        </div>
                        <div class="paginate">
                            <sdl-pagination
                                :current-page="subCurrentPage"
                                :total-rows="subTotalCount"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>
                    </div>
                    <div class="tab_cont" style="display: none;">
                        <div class="grid_wrap">
                            <toast-grid
                                gridId="rhqAnswererManageListGrid"
                                :columns="rhqColumns"
                                :data="rhqAnswerList"
                                :options="options"
                                ref="rhqAnswererManageListGrid"
                                :key="rhqGridKey"
                                :isTotalCount="false"
                                :click="contentClick"
                            />
                        </div>
                        <div class="paginate">
                            <sdl-pagination
                                :current-page="rhqCurrentPage"
                                :total-rows="rhqTotalCount"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>
                    </div>
                    <div class="tab_cont" style="display: none;">
                        <div class="grid_wrap">
                            <toast-grid
                                gridId="gbmAnswererManageListGrid"
                                :columns="gbmColumns"
                                :data="gbmAnswerList"
                                :options="options"
                                ref="gbmAnswererManageListGrid"
                                :key="gbmGridKey"
                                :isTotalCount="false"
                                :click="contentClick"
                            />
                        </div>
                        <div class="paginate">
                            <sdl-pagination
                                :current-page="gbmCurrentPage"
                                :total-rows="gbmTotalCount"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import searchUserPop from '~va/qnaManager/popup/searchUserPop';
import answererAddPop from '~va/qnaManager/popup/answererAddPop';
import answererChangePop from '~va/qnaManager/popup/answererChangePop';
import europeSharedSvcPop from '~va/qnaManager/popup/europeSharedSvcPop';
import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';

export default {
    name: 'answererManageList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    data() {
        return {
            pageName: 'answererManageList',
            pageTitle: '',
            success2: false,
            success3: false,
            success4: false,
            success5: false,
            systemAdminBoolean: false,
            systemAdminYN: 'N',
            inquiry1Code: '',
            inquiry2Code: '',
            category1Code: '',
            category2Code: '',
            category3Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            rhqCode: '',
            rhqCodeList: [],
            searchSubsidiary: '',
            searchSubsidiaryList: [],
            gbm_cd: '',
            gbmCdList: [],
            kpi_charge: '',
            kpiChargeList: [],
            del_yn: 'N',
            mappingYN: 'N',
            disabledGbm: true,
            loginId: '',
            loginNo: '',
            loginNm: '',
            searchDiv: 'SUB',
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            options: {
                scrollX: true,
                scrollY: true,
                header: { height: 45 },
                rowHeight: 45,
                rowHeaders: ['checkbox'],
            },
            subTotalCount: 0,
            subCurrentPage: 1,
            subAnswerList: [],
            subGridKey: 0,
            subColumns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.RHQ'),
                    name: 'RHQ_NM',
                    width: 120,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'),
                    name: 'DEPT_NM',
                    width: 120,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY1'),
                    name: 'PRD_CATEGORY_NM1',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY2'),
                    name: 'PRD_CATEGORY_NM2',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY3'),
                    name: 'PRD_CATEGORY_NM3',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRY_TYPE_NM1',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRY_TYPE_NM2',
                    align: 'center',
                    width: 200,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ID'),
                    name: 'LOGIN_ID',
                    width: 100,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NAME'),
                    name: 'LOGIN_NAME',
                    align: 'center',
                    width: 100,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DELETE'),
                    name: 'ACTIVE',
                    align: 'center',
                    width: 100,
                    sortable: false,
                },
            ],
            rhqTotalCount: 0,
            rhqCurrentPage: 1,
            rhqAnswerList: [],
            rhqGridKey: 0,
            rhqColumns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.RHQ'),
                    name: 'DEPT_NM',
                    width: 120,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY1'),
                    name: 'PRD_CATEGORY_NM1',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY2'),
                    name: 'PRD_CATEGORY_NM2',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY3'),
                    name: 'PRD_CATEGORY_NM3',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRY_TYPE_NM1',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRY_TYPE_NM2',
                    align: 'center',
                    width: 200,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ID'),
                    name: 'LOGIN_ID',
                    width: 100,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NAME'),
                    name: 'LOGIN_NAME',
                    align: 'center',
                    width: 100,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DELETE'),
                    name: 'ACTIVE',
                    align: 'center',
                    width: 100,
                    sortable: false,
                },
            ],
            gbmTotalCount: 0,
            gbmCurrentPage: 1,
            gbmAnswerList: [],
            gbmGridKey: 0,
            gbmColumns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.GBM'),
                    name: 'DEPT_NM',
                    width: 120,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY1'),
                    name: 'PRD_CATEGORY_NM1',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY2'),
                    name: 'PRD_CATEGORY_NM2',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY3'),
                    name: 'PRD_CATEGORY_NM3',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRY_TYPE_NM1',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRY_TYPE_NM2',
                    align: 'center',
                    width: 200,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ID'),
                    name: 'LOGIN_ID',
                    width: 100,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NAME'),
                    name: 'LOGIN_NAME',
                    align: 'center',
                    width: 100,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DELETE'),
                    name: 'ACTIVE',
                    align: 'center',
                    width: 100,
                    sortable: false,
                },
            ],
        };
    },
    mounted() {
        for (let roleCode of this.roles) {
            if ('59' !== roleCode.substring(0, 2) && parseInt(roleCode) < 10000 && '9' === roleCode.substring(1, 2)) {
                if (parseInt(roleCode) >= 4900) {
                    this.success2 = true;
                    this.success3 = true;
                    this.success4 = true;
                } else if (parseInt(roleCode) >= 3900) {
                    this.success2 = true;
                    this.success3 = true;
                } else if (parseInt(roleCode) >= 2900) {
                    this.success2 = true;
                }
            } else if ('7900' === roleCode) {
                this.success5 = true;
            } else if ('9900' === roleCode || '9999' === roleCode) {
                this.systemAdminBoolean = true;
                this.systemAdminYN = 'Y';
            }
        }

        this.categoryList(1);
        this.categoryList(4);
        this.inquiryList(1);
        this.inquiryList(3);
        this.inquiryList(4);
console.log('Current Axios Version:', axios.VERSION); // test
        setTimeout(() => {
            this.onSearch(1);
        }, 1000);
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
        }),
    },
    methods: {
        onSearch(v) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/answererSearch.skp`,
                    qs.stringify({
                        page: v,
                        SEARCH_DIV: this.searchDiv,
                        rhqCode: this.rhqCode,
                        searchSubsidiary: this.searchSubsidiary,
                        gbm_cd: this.gbm_cd,
                        searchCategoryA: this.category1Code,
                        searchCategoryB: this.category2Code,
                        searchCategoryC: this.category3Code,
                        searchInquiryType1: this.inquiry1Code,
                        searchInquiryType2: this.inquiry2Code,
                        kpi_charge: this.kpi_charge,
                        del_yn: this.del_yn,
                        mappingYN: this.mappingYN,
                        searchAnswererNo: this.loginNo,
                    }),
                )
                .then(resp => {
                    let returnSearchDiv = resp.data.search.SEARCH_DIV;
                    if ('SUB' === returnSearchDiv) {
                        this.subAnswerList = resp.data.result.rowData;
                        this.subGridKey++;
                        this.subCurrentPage = Number(resp.data.search.page);
                        this.subTotalCount = resp.data.search.totalRecords;
                    } else if ('RHQ' === returnSearchDiv) {
                        this.rhqAnswerList = resp.data.result.rowData;
                        this.rhqGridKey++;
                        this.rhqCurrentPage = Number(resp.data.search.page);
                        this.rhqTotalCount = resp.data.search.totalRecords;
                    } else if ('GBM' === returnSearchDiv) {
                        this.gbmAnswerList = resp.data.result.rowData;
                        this.gbmGridKey++;
                        this.gbmCurrentPage = Number(resp.data.search.page);
                        this.gbmTotalCount = resp.data.search.totalRecords;
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onExcel() {
            let page = this.subCurrentPage;
            if ('GBM' === this.searchDiv) {
                page = this.gbmCurrentPage;
            } else if ('RHQ' === this.searchDiv) {
                page = this.rhqCurrentPage;
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.EXCEL.ALERT.MAXROWS'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/excelDownload.skp`,
                            qs.stringify({
                                page: page,
                                SEARCH_DIV: this.searchDiv,
                                rhqCode: this.rhqCode,
                                searchSubsidiary: this.searchSubsidiary,
                                gbm_cd: this.gbm_cd,
                                searchCategoryA: this.category1Code,
                                searchCategoryB: this.category2Code,
                                searchCategoryC: this.category3Code,
                                searchInquiryType1: this.inquiry1Code,
                                searchInquiryType2: this.inquiry2Code,
                                kpi_charge: this.kpi_charge,
                                del_yn: this.del_yn,
                                mappingYN: this.mappingYN,
                                searchAnswererNo: this.loginNo,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            if (v === 3) {
                type = 'kpi_charge';
            } else if (v === 4) {
                type = 'gbm_cd';
            }
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Code = '';
                        this.inquiry2Code = '';
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2CodeList = resp.data.result.rowData;
                    } else if (v === 3) {
                        this.kpi_charge = '';
                        this.kpiChargeList = resp.data.result.rowData;
                    } else if (v === 4) {
                        this.gbm_cd = '';
                        this.gbmCdList = resp.data.result.rowData;
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = '';
                this.category3Code = '';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.getUserCorpCd).then(resp => {
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = '';
                this.category3Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.getUserCorpCd).then(resp => {
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3Code = '';
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.getUserCorpCd).then(resp => {
                    this.category3CodeList = resp;
                });
            } else if (v === 4) {
                codeCategoryId = 'RHQ_DATA_ACCESS_CD';
                parentCode = 'organizationRoot';
                this.rhqCode = '';
                this.rhqCodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.curLoginNo).then(resp => {
                    this.rhqCodeList = resp;
                    this.rhqCode = resp[0].code;
                    this.categoryList(5);
                });
            } else if (v === 5) {
                codeCategoryId = 'SUB_DATA_ACCESS_CD';
                parentCode = this.rhqCode;
                this.searchSubsidiary = '';
                this.searchSubsidiaryList = [];
                if (!SDLUtil.isNull(parentCode)) {
                    await this.getCodeComboList(parentCode, codeCategoryId, this.curLoginNo).then(resp => {
                        this.searchSubsidiaryList = resp;
                        this.searchSubsidiary = resp[0].code;
                    });
                }
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        searchUserPop() {
            SDLUtil.show(
                searchUserPop,
                {
                    rtnFunc: (arg1, arg2, arg3) => {
                        this.loginNo = arg1;
                        this.loginId = arg2;
                        this.loginNm = arg3;
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        answererAddPop() {
            SDLUtil.show(
                answererAddPop,
                {
                    SEARCH_DIV: this.searchDiv,
                    searchRhqCode: this.rhqCode,
                    searchSubsidiary: this.searchSubsidiary,
                    searchGbmCd: this.gbm_cd,
                    searchKpiCharge: this.kpi_charge,
                    searchCategoryA: this.category1Code,
                    searchInquiryType1: this.inquiry1Code,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        modify() {
            let checkResult = this.buttonCheck('modify');
            if (checkResult[0]) return SDLUtil.alert(checkResult[1]);

            let grid = this.$refs[this.searchDiv.toLowerCase() + 'AnswererManageListGrid'].$refs[
                this.searchDiv.toLowerCase() + 'AnswererManageListGrid'
            ];
            let getData = grid.invoke('getData');
            let listCheck = [];
            for (const data of getData) {
                if (data._attributes.checked) {
                    listCheck.push(data.ANSWERER_ID);
                }
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.DELETE.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/answererModify.skp`,
                            qs.stringify({
                                listCheck: listCheck,
                                modfUser: this.loginNo,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.alert(resp.data.msg);
                            SDLUtil.showLoadingBar(false);
                            return this.onSearch(1);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        answererChangePop() {
            let checkResult = this.buttonCheck('answererChangePop');
            if (checkResult[0]) return SDLUtil.alert(checkResult[1]);

            let grid = this.$refs[this.searchDiv.toLowerCase() + 'AnswererManageListGrid'].$refs[
                this.searchDiv.toLowerCase() + 'AnswererManageListGrid'
            ];
            let getData = grid.invoke('getData');
            let listCheck = '';
            for (const data of getData) {
                if (data._attributes.checked) {
                    if (!SDLUtil.isNull(listCheck)) listCheck += '^';
                    listCheck += data.ANSWERER_ID;
                }
            }

            let columns = this.subColumns;
            if ('GBM' === this.searchDiv) {
                columns = this.gbmColumns;
            } else if ('RHQ' === this.searchDiv) {
                columns = this.rhqColumns;
            }
            SDLUtil.show(
                answererChangePop,
                { searchDiv: this.searchDiv, listCheck: listCheck, columns: columns },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        europeSharedSvcPop() {
            SDLUtil.show(
                europeSharedSvcPop,
                {
                    // SEARCH_DIV: this.searchDiv,
                    // gbm_cd: this.gbm_cd,
                    rhqCode: this.rhqCode,
                    searchSubsidiary: this.searchSubsidiary,
                    searchCategoryA: this.category1Code,
                    searchCategoryB: this.category2Code,
                    searchCategoryC: this.category3Code,
                    searchInquiryType1: this.inquiry1Code,
                    searchInquiryType2: this.inquiry2Code,
                    targetUser: this.loginNo,
                    targetUserNm: this.loginNm,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        tabClick(v) {
            let MESSAGE = SDLUtil.getMsgProp('MESSAGE.AUTH.NOAUTHORITY').replace(
                ' to {0}',
                '. <br> Please, check your account',
            );
            if (v === 2) {
                if (!this.success4) {
                    SDLUtil.alert(MESSAGE);
                    return;
                }
                this.searchDiv = 'GBM';
                this.disabledGbm = false;
            } else if (v === 1) {
                if (!this.success3) {
                    SDLUtil.alert(MESSAGE);
                    return;
                }
                this.searchDiv = 'RHQ';
                this.disabledGbm = true;
                this.gbm_cd = '';
            } else if (v === 0) {
                if (!this.success2) {
                    SDLUtil.alert(MESSAGE);
                    return;
                }
                this.searchDiv = 'SUB';
                this.disabledGbm = true;
                this.gbm_cd = '';
            }

            $('.tab_wrap li').removeClass('on');
            $('.tab_wrap li')
                .eq(v)
                .addClass('on');
            $('.tab_wrap .tab_cont').hide();
            $('.tab_wrap .tab_cont')
                .eq(v)
                .show();
        },
        resetClick() {
            this.loginNo = '';
            this.loginId = '';
            this.loginNm = '';
        },
        contentClick() {
            console.log('contentClick');
        },
        getTabNo(v) {
            let result = 0;
            if ('SUB' === v) result = 2;
            if ('RHQ' === v) result = 3;
            if ('GBM' === v) result = 4;
            return result;
        },
        buttonCheck(v) {
            let msg = '';
            let result = false;

            if (!this.systemAdminBoolean && !this.deptLevelCd === this.getTabNo(this.searchDiv)) {
                msg = 'Available only in the same level.';
                result = true;
            }

            let grid = this.$refs[this.searchDiv.toLowerCase() + 'AnswererManageListGrid'].$refs[
                this.searchDiv.toLowerCase() + 'AnswererManageListGrid'
            ];
            let getData = grid.invoke('getData');
            let gridChecked = false;
            for (const data of getData) {
                if (data._attributes.checked) {
                    gridChecked = true;
                    if (data.ACTIVE === 'Y') {
                        msg = 'Contains deleted items.';
                        result = true;
                    }
                }
            }

            if (!gridChecked) {
                msg = SDLUtil.getMsgProp('MESSAGE.DATA.CHECKITEM');
                result = true;
            }

            return [result, msg];
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/answererManageList.vue